import { Link, useLocation, useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { useDispatch } from "react-redux";
import { Button } from "antd";
import {  setCurrentStepperStep } from "../modules/ContactUsForm/slice/contactusSlice";
import Footer from "../shared/components/Layout/Footer";
import Nav from "../shared/components/NavBar/Nav";
import calendar from "../shared/assets/images/calendar.svg";
import clock from "../shared/assets/images/blueClock.svg";
import icon from "../shared/assets/images/bookDemoSuccessIcon.svg";
import landingBg from '../shared/assets/images/landingPageAssets/landingBg.svg'
import landingBgMobile from '../shared/assets/images/landingPageAssets/landingBgMobile.svg'
import { useEffect } from "react";
import NotFoundPage from "./NotFoundPage";

export const BookDemoSuccessPage = () => {
  const dispatch = useDispatch()
  const [cookies] = useCookies(['isActive']);
  const { isActive } = cookies;
  const location = useLocation()
  const navigate = useNavigate()

  const closePage = () => {
    dispatch(setCurrentStepperStep(0))
  };

  useEffect(() => {
    const handlePopState = () => {
      if (location?.state?.isBookDemoSuccess) {
        navigate('/book-demo', { state: { isBookDemoSuccess: false } });
      }
    };

    window.addEventListener('popstate', handlePopState);
    //eslint-disable-next-line
  }, [location]);


  return (
    location?.state?.isBookDemoSuccess ? 
    <main>
      <Nav isPublic = {!isActive} />
      <div className='relative text-center'>
        <div className="absolute inset-0 -z-50">
            <img alt='PeopleCQ' src={landingBgMobile} className='object-cover w-full pointer-events-none md:hidden' draggable={false} />
            <img alt='PeopleCQ' src={landingBg} className='hidden object-cover w-full pointer-events-none md:block' draggable={false} />
        </div>
        <div className="flex flex-col items-center justify-center pt-[4.375rem] sm:pt-28 px-6">
          <div className="flex flex-col gap-6 items-center justify-center text-sm text-[#6B7280] w-full max-w-lg bg-white rounded-lg mb-10 p-6 scrollbar-hide">
            <div className="flex flex-col items-center justify-center gap-5">
              <img src={icon} alt="book a demo" className="w-12 h-12" />
              <div className="flex flex-col items-center justify-center gap-2">
                  <div className="text-lg font-medium leading-6 text-center text-gray-900">
                  Thanks for booking!
                </div>
                  <p className="text-sm text-center text-gray-500">
                  We’re excited to show you how our AI-powered platform can simplify and supercharge your hiring process.
                </p>
              </div>
            </div>
              <div className="flex flex-col items-center justify-center w-full gap-2 h-fit">
                <img src={calendar} alt="calender" className="w-6 h-6 mx-auto" />
              <div className="font-bold">What's next?</div>
              <div>You'll receive a confirmation email shortly with all the details and a calendar invite</div>
              <div></div>
            </div>
              <div className="flex flex-col items-center justify-center w-full gap-2 h-fit">
                <img src={clock} alt="clocl" className="w-6 h-6 mx-auto" />
              <div>while you wait for your demo, start your free trial and explore all our features now</div>
              <div></div>
            </div>
            <Link to='/signup' className="w-full">
              <Button className='w-full h-[3.5rem] btn-primary font-medium' htmlType="submit" onClick={closePage}>
                Start Your Free Trial
              </Button>
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </main>
    : <NotFoundPage />
  );
};